import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { App } from '@/app/App'
import '@/styles/global.css'

// Error tracking (AGB-230). No-op unless VITE_SENTRY_DSN is provided at build
// time, so local builds need no Sentry configuration.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'alpha',
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0.05,
    sendDefaultPii: false,
  })
}

const render = () =>
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload.</p>}>
      <App />
    </Sentry.ErrorBoundary>,
  )

// DEV-MOCK (AGB-401) — start. Dev builds only (see `baseApi.ts`).
if (import.meta.env.DEV) {
  import('@/app/entities/finance/__fixtures__/devMock')
    .then(({ installDevMock }) => installDevMock())
    .finally(render)
} else {
  render()
}
// DEV-MOCK — end.
